import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {Switch, Route, Redirect, useLocation, useHistory} from 'react-router-dom'

import { useShallowEqualSelector } from 'custom-hooks'
import {
  getSession,
  getIsLoadingSelector,
  getIsAuthSelector,
  getProfileGroupsSelector,
} from 'redux/reducers/profile'
import { routingConstants } from 'constants/routingConstants'
import PrivateRoute from './PrivateRoute'
import Spinner from 'components/CommonUI/Spinner/Spinner'
import AlertStyled from 'components/CommonUI/Alert/Alert'
import ScrollToTop from 'components/ScrollToTop/ScrollToTop'
import ConfirmationDialogModal from 'components/ConfirmationDialogModal/ConfirmationDialogModal'
import AuthPage from 'pages/AuthPage/AuthPage'
import Overview from 'pages/Overview/Overview'
import Facility from 'pages/Facility/Facility'
import HelpSupport from 'pages/HelpSupport/HelpSupport'
import Equipment from 'pages/Equipment'
import Profile from 'pages/Profile/Profile'
import Header from 'components/Header/Header'
import PageNotFound from 'pages/PageNotFound/PageNotFound'
import DevicesManagement from 'pages/DevicesManagement/DevicesManagement'
import AlertsPage from 'pages/AlertsPage'
import DeviceConnectionPage from 'pages/DeviceConnection'
import PanelsManagement from 'pages/PanelsManagement'
import { getAlerts } from 'redux/reducers/alerts'
import {clearRedirectPageNotFound, getIsRedirectSelector} from '../redux/reducers/isRedirectForPages'

function App() {
  const dispatch = useDispatch()
  const isLoading = useSelector(getIsLoadingSelector)
  const isAuth = useSelector(getIsAuthSelector)
  const { pathname } = useLocation()
  const isRedirect = useSelector(getIsRedirectSelector)
  const history = useHistory()
  const [firstGroup] = useShallowEqualSelector(getProfileGroupsSelector)

  useEffect(() => {
    dispatch(getSession())
  }, [dispatch])

  useEffect(() => {
    if (isAuth) {
      dispatch(getAlerts())
    }
  }, [isAuth, dispatch])

  useEffect(() => {
    if(isRedirect === true) {
      history.push('/*')
    }
    dispatch(clearRedirectPageNotFound())
  }, [history, dispatch, isRedirect])

  if (isLoading) return <Spinner isFullScreen />
  return (
    <div className="container">
      {isAuth && <Header />}
      {!isAuth && pathname.includes(routingConstants.helpSupport) && <Header />}
      <div className="page_container">
        <ScrollToTop />
        <AlertStyled />
        <ConfirmationDialogModal />
        <Switch>
          <PrivateRoute
            path={`${routingConstants.overview}/:overviewId`}
            component={Overview}
            exact
          />
          <PrivateRoute
            path={`${routingConstants.facility}/:facilityId`}
            component={Facility}
            exact
          />
          <Route
            path={routingConstants.helpSupport}
            component={HelpSupport}
            exact
          />
          <PrivateRoute
            path={routingConstants.profile}
            component={Profile}
            exact
          />
          <PrivateRoute
            path={`${routingConstants.equipment}/:facilityId`}
            component={Equipment}
            exact
          />
          <PrivateRoute
            path={routingConstants.devicesManagement}
            component={DevicesManagement}
            exact
            superAdminOnly
          />
          <PrivateRoute
            path={routingConstants.alert}
            component={AlertsPage}
            exact
          />
          <PrivateRoute
            path={routingConstants.devicesConnection}
            component={DeviceConnectionPage}
            exact
            superAdminOnly
          />
          <PrivateRoute
            path={routingConstants.panelsManagement}
            component={PanelsManagement}
            exact
            superAdminOnly
          />
          <Route path={routingConstants.auth} component={AuthPage} />
           <Redirect from="/" to={`${routingConstants.overview}/${firstGroup?.id}`} exact />
          {/*<DefaultRedirectOnOverview exact />*/}
          {/*{isAuth ? (*/}
          {/*  <Route component={PageNotFound} />*/}
          {/*) : (*/}
          {/*  <DefaultRedirectOnOverview />*/}
          {/*)}*/}
          <Route path='*' component={PageNotFound} />
        </Switch>
      </div>
    </div>
  )
}

// const DefaultRedirectOnOverview = ({ exact }) => {
//   const [firstGroup] = useShallowEqualSelector(getProfileGroupsSelector)
//
//   return (
//     <Redirect
//       to={`${routingConstants.overview}/${firstGroup?.id}`}
//       exact={exact}
//     />
//   )
// }

export default App
